import { immerable } from 'immer';

interface ISimulationResultEntity {
	data: Array<Record<string, any>>;
	count: number;
}

const entityDefaults: ISimulationResultEntity = {
	data: [],
	count: 0,
};

export class SimulationResultEntity implements ISimulationResultEntity {
	private [immerable] = true;

	public data = entityDefaults.data;
	public count = entityDefaults.count;

	public static build(
		params: Partial<ISimulationResultEntity> = {}
	): SimulationResultEntity {
		const instance = new SimulationResultEntity();
		instance.data = !params.data
			? entityDefaults.data
			: [...params.data].map((r) =>
					Object.entries(r).reduce<Record<string, any>>((acc, [key, val]) => {
						acc[key] = Array.isArray(val)
							? '[' + val.map((v: unknown) => v ?? 'null').join(', ') + ']'
							: val === null
							? 'null'
							: val;
						return acc;
					}, {} as Record<string, any>)
			  );
		instance.count = params.count ?? entityDefaults.count;

		return instance;
	}
}
